import type { FetchConfig } from '@nlo/nuxt-common/api/helper-types';
import type { components, paths } from '~/generated/krasloten-api';

export type Writable<T> = {
	-readonly [P in keyof T]: T[P] extends ReadonlyArray<infer U> ? Array<Writable<U>> : T[P] extends object ? Writable<T[P]> : T[P];
};

export type Order = Writable<components['schemas']['CreateProductOrderRequestViewModel']>;

export function createCheckoutApi(fetchConfig: FetchConfig) {
	const client = fetchConfig.createClient<paths>();

	return {
		saveOrder(order: Order) {
			return client.POST('/api/order/save', { body: order });
		},
		createOrder() {
			return client.POST('/api/order/create');
		},
	};
}
